import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme: MuiTheme) => {
  const { text } = theme.palette;

  return {
    root: {
      display: "flex",
      flexDirection: "column",
      gap: 12,
      padding: "12px 14px",
      color: "#2d2d2d",
      fontSize: 12,

      "&:nth-child(even)": {
        backgroundColor: "#f6f6f6",
        borderTop: "1px solid #eee",
        borderBottom: "1px solid #eee"
      }
    },
    comment: {
      color: text.secondary,
      fontSize: 10
    }
  };
});
